import httpService from "..";

export const getCronHealthApi = async () => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/admin/cron-health`,
    "get"
  );
};
